<template>
  <section id="Video" class="video">
    <div class="video-container">
      <video
        src="../assets/Images/card1/7989672-hd_1280_720_25fps.mp4"
        class="promo-video"
        ref="videoElement"
        muted
        loop
        autoplay
        playsinline
      ></video>

      <div class="centered-text">
        <h1>A inovação que você sonha, a tecnologia que você precisa.</h1>
        <div class="button-group">
          <button @click="handleContato">Contato</button>
          <button @click="handleSaibaMais">Saiba Mais</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "VideoPromo",
  methods: {
    handleContato() {
      window.location.href = "/contact";
    },
    handleSaibaMais() {
      window.location.href = "/about";
    },
  },
};
</script>

<style scoped>
/* Adicione estas regras para remover espaçamentos indesejados */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%; /* Garante que ocupem 100% da largura */
  height: 100%; /* Garante que ocupem 100% da altura para 100vh funcionar corretamente */
  overflow-x: hidden; /* Evita scroll horizontal */
}

/* Container do vídeo */
.video-container {
  position: relative;
  width: 100%;
  height: 100vh; /* 100% da altura da viewport */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Estilos do vídeo */
.promo-video {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Garante que o vídeo cubra toda a área sem distorcer */
  position: absolute;
  top: 0;
  left: 0;
}

/* Texto centralizado */
.centered-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);
  z-index: 10;
  max-width: 80%;
}

.centered-text h1 {
  font-size: clamp(2rem, 4vw, 4rem);
  margin-bottom: 15px;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.button-group button {
  background-color: #e9a668;
  color: #fff;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.button-group button:hover {
  background-color: hsl(231, 76%, 59%);
  transform: scale(1.07);
}

/* Responsividade */
@media (max-width: 768px) {
  .centered-text h1 {
    font-size: 1.5rem;
  }

  .button-group button {
    font-size: 0.6rem;
    padding: 10px 15px;
  }
}
</style>